import React, { Component } from 'react';
import HeaderEmpty from "../component/header/HeaderEmpty";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Footer from "../component/footer/Footer";

 class error404 extends Component {
    
    render() {
        return (
            <div className="active-dark"> 
            <>
                <HeaderEmpty headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
                {/* Start Page Error  */}
                <div className="error-page-inner bg_color--4 pt--60">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="inner">
                                    <h1 className="title theme-gradient">404!</h1>
                                    <h3 className="sub-title">Looks like you're lost!<span className="sub-span"> (...This page doesn't exist.)</span></h3>
                                    <span>Here's a map and a button to bring you back home.</span>
                                    <div className="error-button">
                                        <img src="/assets/images/featured/map.png"></img>
                                        <a className="rn-button-style--2 btn-solid" href="/">Back To Homepage</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Page Error  */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer /> 
            </>
            </div>
        )
    }
}
export default error404;
